import Main from "@/views/Main.vue";
// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: "/login",
  name: "login",
  meta: {
    title: "Login - 登录",
    accessName: "Login"
  },
  component: () => import("@/views/login.vue")
};

export const page404 = {
  path: "/*",
  name: "error-404",
  meta: {
    title: "404-页面不存在"
  },
  component: () => import("@/views/error-page/404.vue")
};

export const page403 = {
  path: "/403",
  meta: {
    title: "403-权限不足"
  },
  name: "error-403",
  component: () => import("@//views/error-page/403.vue")
};

export const page500 = {
  path: "/500",
  meta: {
    title: "500-服务端错误"
  },
  name: "error-500",
  component: () => import("@/views/error-page/500.vue")
};

export const preview = {
  path: "/preview",
  name: "preview",
  component: () => import("@/views/form/article-publish/preview.vue")
};

export const locking = {
  path: "/locking",
  name: "locking",
  component: () =>
    import("@/views/main-components/lockscreen/components/locking-page.vue")
};

export const externalPart = {
  path: "/externalPart",
  name: "external-part-login",
  meta: {
    title: "外部登录",
    accessName: "externalPart"
  },
  component: () => import("@/views/externalLogin.vue")
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: "/",
  name: 'otherRouter',
  redirect: '/home',
  component: Main,
  children: [
    {
      path: 'home',
      icon: 'home',
      title: '系统首页',
      name: 'home_index',
      meta: {
        accessName: 'home'
      },
      component: () => import("@/views/wzhindex/home.vue")
    },

    // {
    //   path: "monitoringState",
    //   title: "MDM状态",
    //   name: "monitoringState",
    //   meta: {
    //     parentName: "monitoring",
    //     menuName: "monitoring"
    //   },
    //   component: () =>
    //     import("@/views/wzhequipment/monitoring/monitoringState.vue")
    // },
    {
      path: "message",
      title: "消息中心",
      name: "message_index",
      component: () => import("@/views/message/message.vue")
    },
    {
      path: "wizardstart",
      title: "选择模板",
      name: "wizard-start",
      meta: {
        parentName: "meeting-list",
        menuName: "meeting"
      },
      component: () => import("@/views/wzhwizard/template/start.vue")
    },
    {
      path: "wizardtemplate",
      icon: "shuffle",
      title: "填写会议",
      name: "wizard-template",
      component: () => import("@/views/wzhwizard/template/template.vue")
    },
    // { path: 'wizardtemplate', title:'会议模式', name: 'wizard-template', component: () => import('@/views/wzhwizard/template/template.vue')},
    {
      path: "wizardnavigation",
      icon: "shuffle",
      title: "填写向导",
      name: "wizard-navigation",
      meta: {
        parentName: "meeting-template",
        menuName: "system"
      },
      component: () => import("@/views/wzhwizard/navigation/navigation.vue")
    },
    {
      path: "wizardnavigationstart",
      icon: "shuffle",
      title: "选择向导",
      name: "wizard-navigation-start",
      meta: {
        parentName: "meeting-template",
        menuName: "system"
      },
      component: () => import("@/views/wzhwizard/navigation/start.vue")
    },
    {
      path: "meetingedit",
      title: "编辑会议",
      name: "meeting_edit",
      meta: {
        parentName: "meeting-list",
        menuName: "meeting"
      },
      component: () => import("@/views/wzhmeeting/meeting/edit.vue")
    },
    {
      path: "meetingMinutes",
      title: "会议纪要",
      name: "meeting_minutes",
      meta: {
        parentName: "meeting_minutes",
        menuName: "meeting"
      },
      component: () => import("@/views/wzhmeeting/meetingMinutes/meetingMinutes.vue")
    },
    {
      path: "changesMinutes",
      title: "编辑会议纪要",
      name: "changes_minutes",
      meta: {
        parentName: "changes_minutes",
        menuName: "meeting"
      },
      component: () => import("@/views/wzhmeeting/meetingMinutes/changesMinutes.vue")
    },
    {
      path: "meetingConfigEdit",
      title: "会议配置",
      name: "meetingConfig_edit",
      meta: {
        parentName: "",
        menuName: "meeting"
      },
      component: () => import("@/views/wzhmeeting/meetingConfig/meetingConfig.vue")
    },
    {
      path: "topicedit",
      title: "编辑议题",
      name: "topic_edit",
      meta: {
        parentName: "topic-list",
        menuName: "meeting"
      },
      component: () => import("@/views/wzhmeeting/topic/edit.vue")
    },
    {
      path: "fileedit",
      title: "编辑文件",
      parentPath: "/wzhmeeting/files-list",
      parentTitle: "资料列表",
      parentName: "files-list",
      name: "file_edit",
      meta: {
        parentName: "files-list",
        menuName: "meeting"
      },
      // folderadd
      component: () => import("@/views/wzhmeeting/files/edit.vue")
    },
    {
      path: "servicestypeedit",
      title: "编辑服务类型",
      name: "service_type_edit",
      meta: {
        parentName: "services-type",
        menuName: "services"
      },
      component: () => import("@/views/wzhservices/edit.vue")
    },
    {
      path: "editTypeface",
      title: "编辑字体",
      name: "editTypeface",
      meta: {
        parentName: "typefaceList",
        menuName: "editTypeface"
      },
      component: () => import("@/views/wzhsystem/typeface/editTypeface.vue")
    },
    {
      path: "voteedit",
      title: "编辑投票",
      name: "vote_edit",
      meta: {
        parentName: "vote-list",
        menuName: "vote"
      },
      component: () => import("@/views/wzhvote/edit.vue")
    },
    {
      path: "voteresult",
      title: "投票结果",
      name: "vote_result",
      meta: {
        parentName: "vote-list",
        menuName: "vote"
      },
      component: () => import("@/views/wzhvote/result.vue")
    },
    {
      path: "noticeedit",
      title: "添加通知",
      name: "notice_edit",
      meta: {
        parentName: "notice-list",
        menuName: "notice"
      },
      component: () => import("@/views/wzhnotice/edit.vue")
    },
    {
      path: "useredit",
      title: "编辑用户",
      name: "user_edit",
      meta: {
        parentName: "user-list",
        menuName: "user"
      },
      component: () => import("@/views/wzhuser/edit.vue")
    },
    {
      path: "editadministrator",
      title: "编辑管理员",
      name: "edit_administrator",
      meta: {
        parentName: "system-admin",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/admin/editadministrator.vue")
    },
    {
      path: "addadministrator",
      title: "添加管理员",
      name: "add_administrator",
      meta: {
        parentName: "system-admin",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/admin/addadministrator.vue")
    },
    {
      path: "editroom",
      title: "编辑会议室",
      name: "edit_room",
      meta: {
        parentName: "system-room",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/room/editroom.vue")
    },
    {
      path: "addroom",
      title: "添加会议室",
      name: "add_room",
      meta: {
        parentName: "system-room",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/room/editroom.vue")
    },
    {
      path: "editicon",
      title: "编辑终端图标信息",
      name: "edit_icon",
      component: () => import("@/views/wzhsystem/icon/editicon.vue")
    },
    {
      path: "addicon",
      title: "添加终端图标信息",
      name: "add_icon",
      component: () => import("@/views/wzhsystem/icon/addicon.vue")
    },
    {
      path: "addEditScreen",
      title: "修改模板",
      name: "addEdit_screen",
      meta: {
        parentName: "system-sreen",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/sreen/addEditScreen.vue")
    },
    {
      path: "editformat",
      title: "修改文件格式",
      name: "edit_format",
      meta: {
        parentName: "system-format",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/format/editformat.vue")
    },
    {
      path: "addformat",
      title: "新增文件格式",
      name: "add_format",
      meta: {
        parentName: "system-format",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/format/addformat.vue")
    },
    {
      path: "editWebSocket",
      title: "WebSocket配置",
      name: "edit_webSocket",
      component: () => import("@/views/wzhsystem/websocketConfig/edit.vue")
    },
    {
      path: "addTCP",
      title: "TCP配置",
      name: "add_TCP",
      component: () => import("@/views/wzhsystem/TCPconfig/addTCP.vue")
    },
    {
      path: "addserial",
      title: "串口配置",
      name: "add_serial",
      component: () => import("@/views/wzhsystem/serialconfig/addserial.vue")
    },
    {
      path: "editparams",
      title: "修改参数配置",
      name: "edit_params",
      meta: {
        parentName: "system-room",
        menuName: "system"
      },
      component: () => import("@/views/wzhsystem/room/editparams.vue")
    },
    {
      path: "meetingDetail",
      title: "会议详情",
      name: "meeting_detail",
      meta: {
        parentName: "my-audit",
        menuName: "meet"
      },
      component: () => import("@/views/wzhappoint/meetingDetail.vue")
    },
    {
      path: "issueDetails",
      title: "议题详情",
      name: "issueDetails",
      meta: {
        parentName: "issue",
        menuName: "issue"
      },
      component: () => import("@/views/issue/issueDetails.vue")
    },
    {
      path: "issueAdd",
      title: "添加议题",
      name: "issueAdd",
      meta: {
        parentName: "my-issue",
        menuName: "issue"
      },
      component: () => import("@/views/issue/issueAdd.vue")
    },
    {
      path: "addMeeting",
      title: "新增会议",
      name: "addMeeting",
      meta: {
        parentName: "wizard-index",
        menuName: "meet"
      },
      component: () => import("@/views/wzhwizard/template/start.vue")
    },
    {
      path: 'editRelease',
      title: '编辑信息',
      name: 'editRelease',
      meta: {
        parentName: 'release-list',
        menuName: 'release'
      },
      component: () => import('@/views/wzhrelease/editRelease.vue')
    },
    //708新增预约会议
    { path: 'meeting-data-page',
      icon: 'flag',
      title: '预约会议',
      name: 'meeting-data-page',
      meta: { parentName: 'M_Meeting_Data' },
      component: () => import('@/views/wzhappoint/perapplymeet.vue')
    },
    // 可立控
    {
      path: "addApp",
      title: "添加应用",
      name: "add_app",
      meta: {
        parentName: "quick-start",
        menuName: "app"
      },
      component: () => import("@/views/appcontrol/quickstart/addApp.vue")
    },
    {
      path: "addCloudFile",
      title: "添加云盘文件",
      name: "add_cloud",
      meta: {
        parentName: "cloud-desk",
        menuName: "cloud"
      },
      component: () => import("@/views/appcontrol/clouddesk/addCloudFile.vue")
    },
    {
      path: "addMessage",
      title: "添加消息",
      name: "add_message",
      meta: {
        parentName: "message-list",
        menuName: "message"
      },
      component: () => import("@/views/appcontrol/messagelist/addMessage.vue")
    },
    {
      path: "addEditScene",
      title: "添加场景",
      name: "addEditScene",
      meta: {
        parentName: "scene",
        menuName: "scene"
      },
      component: () => import("@/views/scene/addEditScene.vue")
    },
    // {
    //   path: "addSafeSet",
    //   title: "添加安全设置",
    //   name: "addSafeSet",
    //   meta: {
    //     parentName: "safety",
    //     menuName: "safety"
    //   },
    //   component: () => import("@/views/security-settings/addSafeSet.vue")
    // },
    // {
    //   path: "addSafeGroup",
    //   title: "添加分组",
    //   name: "addSafeGroup",
    //   meta: {
    //     parentName: "safety",
    //     menuName: "safety"
    //   },
    //   component: () => import("@/views/security-settings/addSafeGroup.vue")
    // },
    // {
    //   path: "editOrganization",
    //   title: "编辑组织",
    //   name: "edit_organization",
    //   meta: {
    //     parentName: "organization",
    //     menuName: "editorganization"
    //   },
    //   component: () => import("@/views/appcontrol/organization/editroom.vue")
    // },
    // {
    //   path: "addOrganization",
    //   title: "添加组织",
    //   name: "add_organization",
    //   meta: {
    //     parentName: "organization",
    //     menuName: "addorganization"
    //   },
    //   component: () => import("@/views/appcontrol/organization/editroom.vue")
    // },
    {
      path: "configuration",
      title: "参数配置",
      name: "configuration",
      meta: {
        parentName: ["tenant-list","meeting-template"],
        menuName: "configuration"
      },
      component: () => import("@/views/wzhsystem/configuration/configuration.vue")
    },
	{
      path: "editProcessNodes",
      title: "编辑节点",
      name: "editProcessNodes",
      meta: {
        parentName: "system-flowPath",
        menuName: "editProcessNodes"
      },
      component: () => import("@/views/wzhsystem/flowPath/editProcessNodes.vue")
    },
    {
      path: "userMyTaskInfo",
      title: "任务详情",
      name: "userMyTaskInfo",
      meta: {
        parentName: "userMyTask",
        menuName: "userMyTaskInfo"
      },
      component: () => import("@/views/wzhindex/userMyTaskInfo.vue")
    },
    {
      path: "tenantConfig",
      title: "租户配置",
      name: "tenantConfig",
      meta: {
        parentName: "tenant-list",
        menuName: "tenantConfig"
      },
      component: () => import("@/views/tenant/tenantConfig.vue")
    },
    {
      path: 'system-control',
      icon: 'android-options',
      title: '终端布局管理',
      name: 'system-control',
      meta: { parentName: "system-room", menuName: 'M_NodeLayout' },
      component: () => import('@/views/wzhsystem/control/control.vue')
    },
    {
      path: 'editPictureDevice',
      title: '编辑信息',
      name: 'editPictureDevice',
      meta: {
        parentName: 'system-pictureDevice',
        menuName: 'editPictureDevice'
      },
      component: () => import('@/views/wzhsystem/pictureDevice/editPictureDevice.vue')
    },

    {
      path: 'editCameraDevice',
      title: '编辑信息',
      name: 'editCameraDevice',
      meta: {
        parentName: 'system-cameraDevice',
        menuName: 'editCameraDevice'
      },
      component: () => import('@/views/wzhsystem/cameraDevice/editCameraDevice.vue')
    },
  ]
};
// 编辑页
export const editRouter = {
  path: "/",
  name: "editRouter",
  redirect: "/home",
  component: Main,
  children: []
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [{
  path: '/home',
  icon: 'home',
  name: 'index',
  title: '系统首页',
  component: Main,
  children: [{
    path: 'home',
    icon: 'home',
    title: '系统首页',
    name: 'home_index',
    meta: {
      accessName: 'home'
    },
    component: () => import('@/views/wzhindex/home.vue')
  }]
},
/*{
path: '/wzhwizard',
icon: 'paper-airplane',
name: 'wizard',
title: '会议向导',
component: Main,
children: [
{ path: 'wizard-index', icon: 'flag', title: '向导首页', name: 'wizard-index', component: () => import('@/views/wzhwizard/template/index.vue') },
{ path: 'wizardtemplate', icon: 'shuffle', title: '继续向导', name: 'wizard-template', component: () => import('@/views/wzhwizard/template/template.vue') }

]
},*/
// {
//   path: '/meet',
//   icon: 'calendar',
//   name: 'meet',
//   title: '预约管理',
//   component: Main,
//   children: [
//     { path: 'apply-meet', icon: 'ios-alarm', title: '会议预约', name: 'apply-meet', meta:{accessName:'M_Appoint_Apply'}, component: () => import('@/views/wzhappoint/perapplymeet.vue') }
//   ]
// },
{
  path: '/wzhmeeting',
  icon: 'clipboard',
  name: 'meeting',
  title: '会议管理',
  component: Main,
  children: [
    { path: 'wizard-index', icon: 'flag', title: '预约会议', name: 'wizard-index', meta: { accessName: 'M_Meeting_Add' }, component: () => import('@/views/wzhappoint/meetingDataPage.vue') }
    // { path: 'my-appoint', icon: 'ios-compose', title: '我的预约', name: 'my-appoint', meta: { accessName: 'M_Appoint_My_Apply' }, component: () => import('@/views/wzhappoint/myappoint.vue') },
    , { path: 'meeting-list', icon: 'navicon-round', title: '会议列表', name: 'meeting-list', meta: { accessName: 'M_Meeting_List' }, component: () => import('@/views/wzhmeeting/meeting/meetinglist.vue') }
    , { path: 'topic-list', icon: 'clipboard', title: '议题列表', name: 'topic-list', meta: { accessName: 'M_Meeting_Topic' }, component: () => import('@/views/wzhmeeting/topic/topiclist.vue') }
    , { path: 'files-list', icon: 'document', title: '资料列表', name: 'files-list', meta: { accessName: 'M_Meeting_Datum' }, component: () => import('@/views/wzhmeeting/files/fileslist.vue') }
    // ,{ path: 'files-directory', icon: 'folder', title: '资料目录', name: 'files-directory', component: () => import('@/views/wzhmeeting/files/filesdirectory.vue') }
    , { path: 'control-page', icon: 'android-desktop', title: '会议中控', name: 'control-page', meta: { accessName: 'M_MeetingCenter' }, component: () => import('@/views/wzhcontrol/controlpage.vue') }
    , { path: 'vote-list', icon: 'stats-bars', title: '投票管理', name: 'vote-list', meta: { accessName: 'M_Vote' }, component: () => import('@/views/wzhvote/votelist.vue') }
    , { path: 'services-list', icon: 'ios-telephone', title: '呼叫列表', name: 'services-list', meta: { accessName: 'M_ShoutServList' }, component: () => import('@/views/wzhservices/list.vue') }
    , { path: 'notice-list', icon: 'chatbox-working', title: '通知列表', name: 'notice-list', meta: { accessName: 'M_Notic' }, component: () => import('@/views/wzhnotice/noticelist.vue') }
    , { path: 'perfect-meeting-list', icon: 'edit', title: '完善会议', name: 'perfect-meeting-list', meta: { accessName: 'M_Meeting_Complete' }, component: () => import('@/views/wzhmeeting/perfect/perfectlist.vue') }
    , { path: 'statist-meet', icon: 'navicon', title: '会议数据统计', name: 'statist-meet', meta: { accessName: 'meetstatist' }, component: () => import('@/views/wzhstatist/meetstatist/meetingstatist.vue') }
    , { path: 'statist-user', icon: 'android-contacts', title: '会议人员统计', name: 'statist-user', meta: { accessName: 'meetuserstatist' }, component: () => import('@/views/wzhstatist/userstatist/meetuserstatist.vue') }
  ]
},
{
  path: '/issue',
  icon: 'radio-waves',
  name: 'issue',
  title: '议题管理',
  component: Main,
  children: [
    { path: 'my-issue', icon: 'android-options', title: '议题管理', name: 'my-issue', meta: { accessName: 'M_Issue' }, component: () => import('@/views/issue/myissue.vue') }
  ]
},
// {
//   path: '/wzhmymeeting',
//   icon: 'android-list',
//   name: 'mymeeting',
//   title: '我的会议',
//   component: Main,
//   children: [
//     { path: 'start-meeting', icon: 'android-person-add', title: '待参加会议', name: 'start-meeting', meta: { accessName: 'M_My_Meeting_Start' }, component: () => import('@/views/wzhmymeeting/startmeeting.vue') },
//     { path: 'end-meeting', icon: 'android-time', title: '历史会议', name: 'end-meeting', meta: { accessName: 'M_My_Meeting_End' }, component: () => import('@/views/wzhmymeeting/endmeeting.vue') }
//   ]
// },
{
  path: '/release',
  icon: 'map',
  name: 'release',
  title: '信息发布',
  component: Main,
  children: [
    { path: 'release-list', icon: 'map', title: '信息发布', name: 'release-list', meta: { accessName: 'INFOMATION_LIST' }, component: () => import('@/views/wzhrelease/releaseList.vue') }
  ]
},
// {
//   path: '/wzhequipment',
//   icon: 'android-apps',
//   name: 'equipment',
//   title: '设备状态',
//   component: Main,
//   children: [
//     { path: 'monitoring', icon: 'ios-pulse-strong', title: '设备状态', name: 'monitoring', meta: { accessName: 'monitoring' }, component: () => import('@/views/wzhequipment/monitoring/index.vue') },
//     // { path: 'equManage', icon: 'ios-paper', title: '设备管理', name: 'equManage', meta: { accessName: 'equManage' }, component: () => import('@/views/wzhequipment/manage/index.vue') },
//     // { path: 'equAgreement', icon: 'ios-bookmarks', title: '设备协议', name: 'equAgreement', meta: { accessName: 'equAgreement' }, component: () => import('@/views/wzhequipment/agreement/index.vue') },
//     // { path: 'operating', icon: 'gear-b', title: '设备操作', name: 'operating', meta: { accessName: 'operating' }, component: () => import('@/views/wzhequipment/operating/index.vue') },
//     // { path: 'monitor', icon: 'videocamera', title: '设备监控', name: 'monitor', meta: { accessName: 'monitor' }, component: () => import('@/views/wzhequipment/state/index.vue') }
//     //,{ path: 'log-item', icon: 'gear-b', title: '日志事件管理', name: 'log-item', component: () => import('@/views/wzhlog/logitem.vue') }
//     // ,{ path: 'log-type', icon: 'wrench', title: '日志事件类型管理', name: 'log-type', component: () => import('@/views/wzhlog/logtype.vue') }
//   ]
// },
{
  path: '/wzhuser',
  icon: 'person-stalker',
  name: 'user',
  title: '人员管理',
  component: Main,
  children: [
    { path: 'user-list', icon: 'ios-people', title: '人员列表', name: 'user-list', meta: { accessName: 'M_User' }, component: () => import('@/views/wzhuser/userlist.vue') }
    , { path: 'user-company', icon: 'ios-pricetags', title: '部门管理', name: 'user-company', meta: { accessName: 'M_Department' }, component: () => import('@/views/wzhuser/usercompany.vue') }
    , { path: 'user-rank', icon: 'ios-bookmarks', title: '职位管理', name: 'user-rank', meta: { accessName: 'M_Position' }, component: () => import('@/views/wzhuser/userrank.vue') }
  ]
},
// {
//   path: '/zdManagement',
//   icon: 'android-apps',
//   name: 'terminal',
//   title: '终端领用',
//   component: Main,
//   children: [
//     { path: 'terminal-list', icon: 'android-checkmark-circle', title: '领用列表', name: 'terminal-list', meta: { accessName: 'M_Terminal' }, component: () => import('@/views/zdManagement/terminalList/index.vue') }
//     ,{ path: 'binding-item', icon: 'ios-infinite', title: '绑定管理', name: 'binding-item', meta: { accessName: 'M_Binding' }, component: () => import('@/views/zdManagement/terminalBinding/index.vue') }
//   ]
// },
{
  path: '/wzhlog',
  icon: 'android-apps',
  name: 'log',
  title: '日志管理',
  component: Main,
  children: [
    { path: 'log-list', icon: 'ios-paper', title: '日志管理', name: 'log-list', meta: { accessName: 'M_LogCenter' }, component: () => import('@/views/wzhlog/loglist.vue') }
    //,{ path: 'log-item', icon: 'gear-b', title: '日志事件管理', name: 'log-item', component: () => import('@/views/wzhlog/logitem.vue') }
    // ,{ path: 'log-type', icon: 'wrench', title: '日志事件类型管理', name: 'log-type', component: () => import('@/views/wzhlog/logtype.vue') }
  ]
},
// {
//   path: '/task',
//   icon: 'android-document',
//   name: 'task',
//   title: '我的任务',
//   component: Main,
//   children: [
//     { path: 'my-task', icon: 'android-document', title: '我的任务', name: 'my-task', meta: { accessName: 'M_Tast' }, component: () => import('@/views/task/mytask.vue') }
//   ]
// },
// {
//   path: '/task',
//   icon: 'android-list',
//   name: 'task',
//   title: '任务分配',
//   component: Main,
//   children: [
//     { path: 'task-allocation', icon: 'android-list', title: '任务分配', name: 'task-allocation', meta: { accessName: 'F_Tast' }, component: () => import('@/views/task/taskallocation.vue') }
//   ]
// },
{
  path: '/wzhmatrix',
  icon: 'navicon',
  name: 'matrix',
  title: '矩阵管理',
  component: Main,
  children: [
    { path: 'matrix-protocol', icon: 'ios-list-outline', title: '矩阵协议', name: 'matrix-protocol', meta: { accessName: 'matrix-protocol' }, component: () => import('@/views/wzhmatrix/protocol/protocol.vue') }
    , { path: 'matrix-command', icon: 'grid', title: '矩阵命令', name: 'matrix-command', meta: { accessName: 'matrix-command' }, component: () => import('@/views/wzhmatrix/command/command.vue') }
  ]
},
{
  path: '/wzhsystem',
  icon: 'gear-b',
  name: 'system',
  title: '系统管理',
  component: Main,
  children: [
    { path: 'tenant-list', icon: 'ios-location-outline', title: '租户管理', name: 'tenant-list', meta: { accessName: 'M_TenantList' }, component: () => import('@/views/tenant/tenantList.vue') }
    ,{ path: 'system-admin', icon: 'android-contacts', title: '管理员管理', name: 'system-admin', meta: { accessName: 'M_Sys_Admin' }, component: () => import('@/views/wzhsystem/admin/admin.vue') }
    ,{ path: 'node-manage', icon: 'clipboard', title: '终端管理', name: 'node-manage',meta:{accessName:'NODE_MANAGE'}, component: () => import('@/views/wzhsystem/nodeManage/nodeList.vue') }
    ,{ path: 'system-floor-manage', icon: 'cube', title: '楼层管理', name: 'system-floor-manage', meta: { accessName: 'FLOOR_MANAGE' }, component: () => import('@/views/wzhsystem/floorManage/index.vue')}
    , { path: 'system-room', icon: 'social-instagram', title: '会议室管理', name: 'system-room', meta: { accessName: 'M_MeetingRoom' }, component: () => import('@/views/wzhsystem/room/room.vue') }
    , { path: 'meeting-template', icon: 'toggle-filled', title: '会议类型', name: 'meeting-template', meta: { accessName: 'M_MeetingTemplate' }, component: () => import('@/views/wzhsystem/meetingtemplate/meetingtemplatelist.vue') }
    , { path: 'system-format', icon: 'filing', title: '文件格式管理', name: 'system-format', meta: { accessName: 'M_FileFormat' }, component: () => import('@/views/wzhsystem/format/format.vue') }
    , { path: 'system-power', icon: 'female', title: '角色权限管理', name: 'system-power', meta: { accessName: 'M_Authority_role,M_Authority_Per,M_Authori_Module' }, component: () => import('@/views/wzhsystem/power.vue') }
    , { path: 'system-sreen', icon: 'android-expand', title: '前后屏模板管理', name: 'system-sreen', meta: { accessName: 'M_LayoutTemplate' }, component: () => import('@/views/wzhsystem/sreen/sreen.vue') }
    , { path: 'system-voice', icon: 'mic-c', title: '声纹管理', name: 'system-voice', meta: { accessName: 'M_LayoutTemplate' }, component: () => import('@/views/wzhsystem/voice/voice.vue') }
    , { path: 'system-flowPath', icon: 'arrow-graph-up-right', title: '流程审批模板管理', name: 'system-flowPath', meta: { accessName: 'WORKFLOW_APPROVAL_MANAGE' }, component: () => import('@/views/wzhsystem/flowPath/flowPathTemplate.vue') }
    , { path: 'system-minutes', icon: 'ios-copy', title: '会议纪要模板管理', name: 'system-minutes', meta: { accessName: 'M_MinutesTemplate' }, component: () => import('@/views/wzhsystem/systemMinutes/systemMinutes.vue') }
    , { path: 'system-wizard', icon: 'ios-paperplane', title: '会议向导管理', name: 'system-wizard', meta: { accessName: 'M_MeetingNav' }, component: () => import('@/views/wzhsystem/wizard.vue') }
    , { path: 'services-type', icon: 'settings', title: '呼叫类型管理', name: 'services-type', meta: { accessName: 'M_ShoutServTypeM' }, component: () => import('@/views/wzhservices/type.vue') }
    // , { path: 'layout-model', icon: 'android-star-outline', title: '布局图标管理', name: 'layout-model', meta: { accessName: 'M_IconMould' }, component: () => import('@/views/wzhsystem/icon/layoutmodel.vue') }
    // , { path: 'model-item', icon: 'navicon-round', title: '布局方案项管理', name: 'model-item', meta: { accessName: 'M_LayoutScheme' }, component: () => import('@/views/wzhsystem/icon/modelitem.vue') }
    , { path: 'system-equipment', icon: 'ios-briefcase', title: '基础设备管理', name: 'system-equipment', meta: { accessName: 'BASE_DEVICE_LIST' }, component: () => import('@/views/wzhsystem/equipment/index.vue')}
    , { path: 'virtual-machine', icon: 'fireball', title: '虚拟机管理', name: 'system-vms', meta: { accessName: 'M_Sys_vms' }, component: () => import('@/views/virtual/machine.vue') }
    ,{ path: 'system-hotWords', icon: 'fireball', title: '热词管理', name: 'system-hotWords',meta:{accessName:'M_Sys_hotWords'}, component: () => import('@/views/wzhsystem/hotWords/hotWords.vue') }
    ,{ path: 'system-typeface', icon: 'social-tumblr-outline', title: '字体管理', name: 'system-typeface',meta:{accessName:'FONT_MANAGE'}, component: () => import('@/views/wzhsystem/typeface/typefaceList.vue') }
    , { path: 'system-deploy', icon: 'ios-settings-strong', title: '参数配置管理', name: 'system-deploy', meta: { accessName: 'M_ParamDeploy,M_WebSocket,M_TCP,M_SerialPortsMan' }, component: () => import('@/views/wzhsystem/paraconfig.vue') }
    , { path: 'system-topic', icon: 'ios-paper', title: '拓展信息管理', name: 'system-topic', meta: { accessName: 'M_TopicTypeM' }, component: () => import('@/views/wzhsystem/topictype.vue') }
    //  {
    //   path: 'system-timing-manage',
    //   icon: 'ios-stopwatch',
    //   title: '定时管理',
    //   name: 'system-timing-manage',
    //   meta: { accessName: 'DSGL' },
    //   component: () => import('@/views/wzhsystem/timingManage/index.vue')
    // }
    //结束
    , { path: 'system-mdm-management', icon: 'locked', title: 'MDM管控', name: 'system-mdm-management', meta: { accessName: 'MDM_MANAGE' }, component: () => import('@/views/wzhsystem/mdmManagement/mdmManagement.vue') }
    // , { path: 'room-doorplate', icon: 'android-laptop', title: '门牌管理', name: 'room-doorplate', meta: { accessName: 'M_Room_Doorplate' }, component: () => import('@/views/wzhdoorplate/roomdoorplatelist.vue') }
    // ,{ path: 'system-config', icon: 'ios-toggle', title: '许可号配置', name: 'system-config', component: () => import('@/views/wzhsystem/config.vue') }
    // ,{ path: 'system-menu', icon: 'toggle-filled', title: '系统菜单配置', name: 'system-menu', component: () => import('@/views/wzhsystem/menu.vue') }
    // ,{path:'system-webSocket',icon: 'android-navigate',title:"WEBSOCKET配置",name:"system-webSocket",component: () => import('@/views/wzhsystem/webSocketConfig/list.vue')}
    // ,{path:'system-tcp',icon: 'android-navigate',title:"TCP配置",name:"system-tcp",component: () => import('@/views/wzhsystem/TCPconfig/TCP.vue')}
    // ,{path:'system-serial',icon: 'android-navigate',title:"串口配置",name:"system-serial",component: () => import('@/views/wzhsystem/serialconfig/serial.vue')}
    , { path: 'system-pictureDevice', icon: 'ios-paper', title: '录像设备管理', name: 'system-pictureDevice', meta: { accessName: 'PICTURE_DEVICE' }, component: () => import('@/views/wzhsystem/pictureDevice/pictureDevice.vue') }
    , { path: 'system-pictureRecord', icon: 'ios-bookmarks', title: '录像记录', name: 'system-pictureRecord', meta: { accessName: 'PICTURE_RECORD' }, component: () => import('@/views/wzhsystem/pictureRecord/pictureRecord.vue') }
    , { path: 'system-cameraDevice', icon: 'android-laptop', title: '信号源管理', name: 'system-cameraDevice', meta: { accessName: 'CAMERA_DEVICE' }, component: () => import('@/views/wzhsystem/cameraDevice/cameraDevice.vue') }


  ]
}
];
// 可立控
// export const appRouter = [
//   {
//     path: '/home',
//     icon: 'home',
//     name: 'index',
//     title: '系统首页',
//     component: Main,
//     children: [{
//       path: 'home',
//       icon: 'home',
//       title: '系统首页',
//       name: 'home_index',
//       meta: {
//         accessName: 'home'
//       },
//         component: () => import("@/views/dashboard/index.vue")
//       }
//     ]
//   },
//   {
//     path: "/scene",
//     icon: "aperture",
//     name: "scene",
//     title: "场景",
//     component: Main,
//     children: [
//       {
//         path: "scene",
//         icon: "clipboard",
//         title: "场景列表",
//         name: "scene_index",
//         meta: { accessName: "scene" },
//         component: () => import("@/views/scene/scene.vue")
//       },
//       {
//         path: "/policy",
//         icon: "flag",
//         title: "策略模板",
//         name: "/policy",
//         meta: { accessName: "scene" },
//         component: () => import("@/views/scene/policy.vue")
//       }
//     ]
//   },
//   {
//     path: "/devmonitor",
//     icon: "android-apps",
//     name: "device",
//     title: "设备监控",
//     component: Main,
//     children: [
//       {
//         path: "devmonitor",
//         icon: "ios-pulse-strong",
//         title: "设备监控",
//         name: "devmonitor",
//         meta: { accessName: "devmonitor" },
//         component: () => import("@/views/devmonitor/index.vue")
//       }
//     ]
//   },
//   {
//     path: "/messagelist",
//     icon: "android-apps",
//     name: "messagelist",
//     title: "消息",
//     component: Main,
//     children: [
//       {
//         path: "message-list",
//         icon: "ios-list-outline",
//         title: "消息",
//         name: "message-list",
//         meta: { accessName: "messagelist" },
//         component: () => import("@/views/appcontrol/messagelist/index.vue")
//       }
//     ]
//   },
//   {
//     path: "/clouddesk",
//     icon: "android-apps",
//     name: "clouddesk",
//     title: "云盘管理",
//     component: Main,
//     children: [
//       {
//         path: "cloud-desk",
//         icon: "android-cloud-outline",
//         title: "云盘管理",
//         name: "cloud-desk",
//         component: Main,
//         meta: { accessName: "clouddesk" },
//         component: () => import("@/views/appcontrol/clouddesk/index.vue")
//       }
//     ]
//   },
//   {
//     path: "/quickstart",
//     icon: "android-apps",
//     name: "quickstart",
//     title: "应用管理",
//     component: Main,
//     children: [
//       {
//         path: "quick-start",
//         icon: "android-apps",
//         title: "应用列表",
//         name: "quick-start",
//         meta: { accessName: "quickstart" },
//         component: () => import("@/views/appcontrol/quickstart/index.vue")
//       },
//       {
//         path: "black-white",
//         icon: "android-star-half",
//         title: "黑白名单",
//         name: "black-white",
//         meta: { accessName: "blackwhite" },
//         component: () => import("@/views/appcontrol/quickstart/blackwhite.vue")
//       }
//     ]
//   },
//   {
//     path: "/organization",
//     icon: "social-buffer",
//     name: "organization",
//     title: "组织",
//     component: Main,
//     children: [
//       {
//         path: "organization",
//         icon: "ios-paper-outline",
//         title: "组织列表",
//         name: "organization-list",
//         meta: { accessName: "organization" },
//         component: () =>
//           import("@/views/appcontrol/organization/organization.vue")
//       },
//       {
//         path: "other-manage",
//         icon: "briefcase",
//         title: "设备控制",
//         name: "other-manage",
//         meta: { accessName: "othermanage" },
//         component: () => import("@/views/appcontrol/othermanage/index.vue")
//       },
//       {
//         path: "link-list",
//         icon: "link",
//         title: "连接列表",
//         component: Main,
//         name: "link-list",
//         meta: { accessName: "linklist" },
//         component: () => import("@/views/appcontrol/linklist/index.vue")
//       }
//     ]
//   },
//   {
//     path: "/personnel",
//     icon: "person-stalker",
//     name: "user",
//     title: "人员管理",
//     component: Main,
//     children: [
//       {
//         path: "user-list",
//         icon: "ios-people",
//         title: "人员列表",
//         name: "user-list",
//         meta: { accessName: "M_User" },
//         component: () => import("@/views/personnel/userlist.vue")
//       },
//       {
//         path: "user-grouping",
//         icon: "android-contacts",
//         title: "分组管理",
//         name: "user-grouping",
//         meta: { accessName: "M_Grouping" },
//         component: () => import("@/views/personnel/usergrouping.vue")
//       },
//       {
//         path: "user-company",
//         icon: "ios-pricetags",
//         title: "部门管理",
//         name: "user-company",
//         meta: { accessName: "M_Department" },
//         component: () => import("@/views/personnel/usercompany.vue")
//       },
//       {
//         path: "user-rank",
//         icon: "ios-bookmarks",
//         title: "职位管理",
//         name: "user-rank",
//         meta: { accessName: "M_Position" },
//         component: () => import("@/views/personnel/userrank.vue")
//       }
//     ]
//   },
//   {
//     path: "/authorization-node",
//     icon: "ipad",
//     name: "authorization-node",
//     title: "终端授权",
//     component: Main,
//     children: [
//       {
//         path: "authorization-node",
//         icon: "network",
//         title: "授权列表",
//         name: "nodeauth",
//         meta: { accessName: "nodeauth" },
//         component: () => import("@/views/authorization-node/list.vue")
//       },
//       {
//         path: "terminal-list",
//         icon: "android-checkmark-circle",
//         title: "领用记录",
//         name: "terminal-list",
//         meta: { accessName: "M_Terminal" },
//         component: () => import("@/views/authorization-node/terminalList.vue")
//       },
//       {
//         path: "binding-item",
//         icon: "ios-infinite",
//         title: "绑定管理",
//         name: "binding-item",
//         meta: { accessName: "M_Binding" },
//         component: () =>
//           import("@/views/authorization-node/terminalBinding.vue")
//       }
//     ]
//   },
//   {
//     path: "/security-settings",
//     icon: "gear-a",
//     name: "safety",
//     title: "安全设置",
//     component: Main,
//     children: [
//       {
//         path: "WiFi",
//         icon: "wifi",
//         title: "WiFi列表",
//         name: "WiFi",
//         meta: { accessName: "WiFi" },
//         component: () => import("@/views/security-settings/WiFiList.vue")
//       },
//       {
//         path: "BlueTooth",
//         icon: "bluetooth",
//         title: "电子围栏列表",
//         name: "Bluetooth",
//         meta: { accessName: "Bluetooth" },
//         component: () => import("@/views/security-settings/BlueToothList.vue")
//       },
//       {
//         path: "SafeGroup",
//         icon: "ios-paper-outline",
//         title: "分组管理",
//         name: "SafeGroup",
//         meta: { accessName: "groupList" },
//         component: () => import("@/views/security-settings/GroupList.vue")
//       }

//     ]
//   },
//   {
//     path: "/systemconfig",
//     icon: "gear-b",
//     name: "systemconfig",
//     title: "系统设置",
//     component: Main,
//     children: [
//       {
//         path: "administrator",
//         icon: "android-contacts",
//         title: "管理员",
//         name: "administrator",
//         meta: { accessName: "administrator" },
//         component: () =>
//           import("@/views/systemconfig/administrator/administrator.vue")
//       },
//       {
//         path: "mdm-manage",
//         icon: "grid",
//         title: "MDM基础设置",
//         component: Main,
//         name: "mdm-manage",
//         meta: { accessName: "mdmmanage" },
//         component: () => import("@/views/systemconfig/mdmmanage/index.vue")
//       },
//       {
//         path: "system-config",
//         icon: "ios-settings-strong",
//         title: "参数配置管理",
//         name: "system-config",
//         meta: {
//           accessName: "M_ParamDeploy,M_WebSocket,M_TCP,M_SerialPortsMan"
//         },
//         component: () => import("@/views/systemconfig/paraconfig.vue")
//       }
//     ]
//   }
// ];
// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  externalPart,
  otherRouter,
  preview,
  locking,
  ...appRouter,
  page500,
  page403,
  page404,
  editRouter
];



// WEBPACK FOOTER //
// ./src/router/router.js